import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { BaseViewComponent } from '@base-shared/components/base-view/base-view.component';
import { AuthGuard, AnonymousGuard } from '@base-guards/index';
import { AppComponent } from './app.component';

export const routingConfiguration: ExtraOptions = {
  paramsInheritanceStrategy: 'always',
  onSameUrlNavigation: 'reload',
};

const routes: Routes = [
  {
    path: 'auth',
    component: AppComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
      },
      {
        path: 'signup',
        loadChildren: '@base/modules/signup/signup.module#SignupModule',
      },
      {
        path: 'login',
        loadChildren: '@base/modules/login/login.module#LoginModule',
        canActivate: [AnonymousGuard]
      },
      {
        path: 'forgot-password',
        loadChildren: '@base/modules/forgot-password/forgot-password.module#ForgotPasswordModule',
        canActivate: [AnonymousGuard]
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routingConfiguration)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
